module.exports = __webpack_public_path__ + "img/login.a6f0de68.png";